import { getBrandConfigForSubdomain } from "./config";
import { getEffectiveBrandKey } from "./detector";

/**
 * Applies brand styling classes to the DOM before React mounts
 * This prevents any visual flicker when switching themes
 */
export function applyBrandConfig(): void {
  const brandKey = getEffectiveBrandKey();
  const brandConfig = getBrandConfigForSubdomain(brandKey);

  const rootElement = document.documentElement;

  // Add the brand class to the html element
  rootElement.classList.add("brand-configured", brandConfig.className);
}
